import { Component } from '@angular/core';
import { CreateQuoteI } from '@interfaces/quote';
import { QuoteServiceService } from '@services/quote-service.service';

@Component({
  selector: 'app-quote-confirmation-page',
  standalone: false,
  templateUrl: './quote-confirmation-page.component.html',
  styleUrls: ['./quote-confirmation-page.component.scss'],
})
export class QuoteConfirmationPage {
  get quote(): CreateQuoteI {
    return this.quoteService.getCurrentQuote();
  }

  constructor(private quoteService: QuoteServiceService) {}
}

